<template>
    <v-form
            ref="modifyVarietyForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="">
            <div class="d-flex align-center primary pl-3 pr-2 pt-1">
                <div class="flex-grow-1 sub--text">
                    {{variety.id ? 'Edit Variety' : 'Create Variety'}}
                </div>
                <div v-if="!variety.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="px-2 pb-1" style="overflow-x: hidden; overflow-y: hidden">
                <v-text-field
                        label="Variety Name"
                        hide-details="auto"
                        v-model="variety.description"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                        :error-messages="varietyNameErrorMessages"
                />
                <v-text-field
                        label="Variety Rate"
                        hide-details="auto"
                        v-model="variety.rate"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull, validationRules.numberOnly, validationRules.notZero]"
                        type="number"
                />
                <v-autocomplete
                        label="Farm"
                        hide-details="auto"
                        no-data-text="No available farms"
                        v-model="variety.fkFarm"
                        item-text="description"
                        item-value="id"
                        :items="[{id: null, description: 'All Farms'}].concat(disabledFarms)"
                        @input="changesMade = true"
                        clearable
                        @click.clear="changesMade = true"
                />
            </div>
            <div class="text-right pr-2 pt-2 pb-2">
                <v-btn
                        @click="validateSave()"
                        fab
                        small
                        color="secondary"
                        :loading="loading"
                        :disabled="!changesMade || loading"
                >
                    <v-icon v-if="!loading">mdi-content-save</v-icon>
                </v-btn>
            </div>
        </div>
    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "../../../core/codeFunctions";

export default {
    components: {},
    props: {
        editVariety: Object
    },
    data() {
        return {
            variety: null,
            varietyNameErrorMessages: null,
            loading: false,
            validationRules: validationRules,
            changesMade: false
        }
    },
    watch: {
        editVariety: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                console.log(val)
                this.variety = JSON.parse(JSON.stringify(val))
            }
        },
        "variety.description"() {
            this.varietyNameErrorMessages = null
        }
    },
    methods: {
        validateSave() {
            if (this.varieties.filter(obj => obj.id !== this.variety.id && obj.description.toLowerCase() === this.variety.description.toLowerCase()).length) {
                this.varietyNameErrorMessages = 'Variety name already exists'
                return false
            }

            if (!this.$refs.modifyVarietyForm.validate())
                return false

            this.$emit('save', {variety: this.variety, ref: this})
        }
    },
    computed: {
        ...mapGetters(['varieties', 'farms', "availableFarms"]),
        disabledFarms() {
            const availableFarmsArr = this.availableFarms.map(obj => obj.id)
            return this.farms.map(farm => {
                return {
                    ...farm,
                    disabled: !availableFarmsArr.includes(farm.id)
                }
            })
        }
    },
}
</script>

<style scoped>

</style>